import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between p-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Apply ")
const _hoisted_3 = {
  key: 0,
  class: "absolute rounded m-2 p-2 bg-theme-500 font-medium shadow-sm text-white",
  style: {"z-index":"999999999"}
}
const _hoisted_4 = {
  class: "flex justify-between",
  style: {"line-height":"1"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pr-1" }, "w: ", -1)
const _hoisted_6 = {
  class: "flex justify-between",
  style: {"line-height":"1"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "pr-1" }, "h: ", -1)
const _hoisted_8 = { style: {"text-align":"right"} }

import { toRefs, computed, ref, watch } from "vue";

// Components
import {
    AppButton as Button,
    AppLoader as Loader,
} from "@greywind/ui";

// Import image cropper
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';


export default /*#__PURE__*/_defineComponent({
  props: {
        image: {
            type:     String,
            required: true,
        },
        imageType: {
            type: String,
            required: false,
            default: 'image/jpeg'
        },
        interacting: {
            type: Boolean,
            required: false,
            default: false
        }
    },
  emits: ['apply'],
  setup(__props, { emit }) {

const props = __props



const { image, imageType, interacting } = toRefs( props );



const cropperEl = ref(null);

const imageTransforms = ref({
    width: 0,
    height: 0,
    rotation: 0,
});

const rotateCropper = (angle: number) => {
    cropperEl.value.rotate(angle);
}

const flipCropper = (x,y) => {
    cropperEl.value.flip(x, y);
}

const zoomCropper = ( factor: number ) => {
    cropperEl.value.zoom(factor);
}

const resetCropper = () => {
    cropperEl.value.reset();
}

const onCropperChange = ( { coordinates, image }: any ) => {
    if (!cropperEl.value )return;

    imageTransforms.value.width = coordinates.width;
    imageTransforms.value.height = coordinates.height;
    imageTransforms.value.rotation = image.transforms.rotate;
};

const returnCropping = async () => {
    if ( !cropperEl.value ) return;

    const { canvas } = cropperEl.value.getResult();
    const croppedImage = canvas.toDataURL( imageType );

    emit('apply', { croppedImage, transforms: imageTransforms.value } );
}


return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (rotateCropper(90)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.rotate-right",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (rotateCropper(-90)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.rotate-left",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (zoomCropper(2)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.magnifying-glass-plus",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (zoomCropper(0.5)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.magnifying-glass-minus",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (flipCropper(true, false)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.circle-half-stroke",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (flipCropper(false, true)), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.circle-half-stroke",
          "fa-type": "fas",
          class: "h-5 w-5",
          style: {"transform":"rotate(-90deg)"}
        })
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (resetCropper()), ["prevent"]))
      }, [
        _createVNode(_component_x_icon, {
          icon: "fontawesome.arrows-rotate",
          "fa-type": "fas",
          class: "h-5 w-5"
        })
      ]),
      _createVNode(_unref(Button), { onClick: returnCropping }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    (imageTransforms.value.height > 0 && imageTransforms.value.width > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, _toDisplayString(imageTransforms.value.width) + "px", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(imageTransforms.value.height) + "px", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Cropper), {
      ref_key: "cropperEl",
      ref: cropperEl,
      src: _unref(image),
      debounce: true,
      "image-restriction": "none",
      onChange: onCropperChange
    }, null, 8, ["src"]),
    (_unref(interacting))
      ? (_openBlock(), _createBlock(_unref(Loader), {
          key: 1,
          class: "absolute text-theme-500",
          background: "rgba(0,0,0,0.5)",
          style: {"z-index":"999999999999 !important"}
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})